import { useWindowSize } from 'react-use'
import { useMemo } from 'react'

/**
 * Px per frame speed of the grid scroll.
 */
const SPEED = 1
const VISIBLE_COLUMNS_BUFFER = 2
const MOBILE_BREAKPOINT = 768
/**
 * Pattern for the number of rows per column in the grid.
 * Adjust this array to change the grid's column heights.
 */
const COLUMN_HEIGHTS_PATTERN = [2, 2, 3]
const MOBILE_COLUMN_WIDTHS = [200, 160, 120]
const DESKTOP_COLUMN_WIDTHS = [350, 260, 200]

const useGridConfig = () => {
    const { width: viewportWidth } = useWindowSize()
    const isMobile = viewportWidth < MOBILE_BREAKPOINT

    return useMemo(() => {
        const columnWidths= isMobile ? MOBILE_COLUMN_WIDTHS : DESKTOP_COLUMN_WIDTHS
        const gutter = isMobile ? 12 : 20

        /**
         * Calculate the number of visible columns based on the viewport width.
         */
        const avgWidth =
            columnWidths.reduce((a, b) => a + b, 0) / columnWidths.length
        const visibleCount   = Math.ceil(viewportWidth / avgWidth)
        const initialColumns = visibleCount + VISIBLE_COLUMNS_BUFFER

        return {
            speed: SPEED,
            columns: COLUMN_HEIGHTS_PATTERN,
            columnWidths,
            gutter,
            initialColumns,
        }
    }, [isMobile, viewportWidth])
}

export default useGridConfig
